var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import BS_Carousel from 'bootstrap/js/dist/carousel';
export class Carousel extends Component {
    constructor() {
        super('Carousel', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.carousel').each((carousel) => {
                Carousel.carousels.push(new BS_Carousel(carousel.get(0), {
                    ride: carousel.data('ride') == 'false' ? false : 'carousel',
                    pause: carousel.data('pause') == 'false' ? false : 'hover',
                    touch: true,
                }));
            });
            // Update the current slide number on slide change
            $('.carousel').on('slid.bs.carousel', (event) => {
                const carousel = $(event.target);
                const currentSlide = carousel.find('.carousel-item.active').index() + 1;
                carousel.parents('.project').find('.carousel-current-slide').text(currentSlide.toString());
            });
            this.success();
        });
    }
    static getInstance(carouselID) {
        return Carousel.carousels.find((carousel) => carousel._element.id === carouselID);
    }
    static next(carouselID) {
        var _a;
        (_a = this.getInstance(carouselID)) === null || _a === void 0 ? void 0 : _a.next();
    }
    static prev(carouselID) {
        var _a;
        (_a = this.getInstance(carouselID)) === null || _a === void 0 ? void 0 : _a.prev();
    }
}
Carousel.carousels = [];
